export const PUBLIC_PROFILE_PAGE = 'publicProfile';

// public profile pages sidebar top offset to stick it 16px below the top as we have a margin-top of 92px
export const PROFILE_SIDEBAR_TOP_OFFSET = -76;
